<template>
    <v-card outlined tile>
        <v-card-title>
            Historico
            <v-spacer></v-spacer>
            <DateInput
                v-model="date"
                label="Fecha"
                dense
                clearable
                />
        </v-card-title>
        <v-card-text class="pa-0">
            <v-data-table
                :headers="headers"
                :items="divisaRateList"
                :options.sync="options"
                :server-items-length="divisaRateCount"
                :loading="divisaRateListLoading"
                dense
                disable-sort
                >
                <!-- eslint-disable-next-line -->
                <template v-slot:item.created_at="{ item }">
                    <div class="d-flex">
                        <div>{{ item.created_at | datetime }}</div>
                    </div>
                </template>
                <!-- eslint-disable-next-line -->
                <template v-slot:item.rate="{ item }">
                    <div class="d-flex">
                        <div>{{ item.rate | currency(item.divisa_id) }}</div>
                    </div>
                </template>
            </v-data-table>
        </v-card-text>
    </v-card>
</template>
<script>
import DivisaService from '@/services/operadora/general/DivisaService';

const defaultOptions = {page: 1, itemsPerPage: 10};

export default {
    props: {
        params: {},
        divisa: {},
        divisaDefault: {},
    },
    data: function () {
        return {
            date: null,
            headers: [{text: 'Fecha', value: 'created_at'}, {text: 'Tasa', value: 'rate'}],
            divisaRateListLoading: false,
            divisaRateList: [],
            options: {... defaultOptions},
            divisaRateCount: 0,
        }
    },
    methods: {
        getRateList: function (params) {
            this.divisaRateListLoading = true;
            this.divisaRateList = [];

            DivisaService.getRateList({ ...params, target_id: this.divisa.id })
                .then(({ divisaRateList, count }) => {
                    this.divisaRateList = divisaRateList;
                    this.divisaRateCount = count;
                })
                .finally(() => this.divisaRateListLoading = false)
        },
        getOptions: function () { 
            const params = {};
            let itemsPerPage = null;
            if (this.options.itemsPerPage !== -1) itemsPerPage = this.options.itemsPerPage
            else if (this.divisaRateCount) itemsPerPage = this.divisaRateCount
            params['limit'] = itemsPerPage;
            params['offset'] = (this.options.page * itemsPerPage) - itemsPerPage;
            return params;
        },
    },
    mounted: function () {
        this.getRateList(this.getOptions());
    },
    watch: {
        options: {
            handler: function (value, old) {
                if (this.$lodash.isEqual(value.page, old.page) && this.$lodash.isEqual(value.itemsPerPage, old.itemsPerPage)) return;
                this.getRateList(this.getOptions()); 
            },
            deep: true,
        },
        date: function (value, old) {
            if (this.$lodash.isEqual(value, old)) return;
            this.options = {... defaultOptions};
            this.getRateList({date: value, ... this.getOptions()}); 
        },
        params: {
            handler: function (value, old) {
                if (this.$lodash.isEqual(value, old)) return;
                this.options = {... defaultOptions};
                this.getRateList(this.getOptions()); 
            },
            deep: true,
        },
    },
}
</script>